module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/mlb/runs-c0b4dcdc6ba903e42e15ad4ebeb37bbf.svg";